module.exports = __webpack_public_path__ + "media/images/weather/414_night-9d6df5a2d1629dc084f12ac2879896ce.png";